import { ApiError } from "@/shared/api";

/**
 * 已知问题修复批 1002:改挂 / 解约后终端用户找不到登录地址。后端在 PARTNER_DOMAIN_MISMATCH / PARTNER_NOT_FOUND 上,
 * **只在凭据校验通过后**把该账号当前归属的登录地址放进 details(`loginUrl=https://…`);凭据错一律不带。
 * 这里只认 http(s) 绝对地址,其余(缺省 / 脏值 / javascript: 之类)一律当没有 —— 不把后端串直接塞进 href。
 */
export function migratedLoginUrl(err: unknown): string | null {
  if (!(err instanceof ApiError)) return null;
  if (err.errorCode !== "PARTNER_DOMAIN_MISMATCH" && err.errorCode !== "PARTNER_NOT_FOUND") {
    return null;
  }
  const raw = (err.details ?? [])
    .map((d) => d.trim())
    .find((d) => d.startsWith("loginUrl="))
    ?.slice("loginUrl=".length);
  if (!raw) return null;
  try {
    const u = new URL(raw);
    if (u.protocol !== "https:" && u.protocol !== "http:") return null;
    return u.origin + (u.pathname === "/" ? "" : u.pathname);
  } catch {
    return null;
  }
}
